module.exports = __webpack_public_path__ + "img/btn-Transparencia.d8f8a5ee.png";